// project import
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  return (
    <SimpleBar
      rootSx={{ minHeight: 'calc(50vh - 32px)', maxHeight: { lg: 'calc(100vh - 64px)' } }}
      sx={{
        my: '16px',
        maxHeight: { xs: 'calc(100vh - 32px)', lg: 'calc(100vh - 96px)' },
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <Navigation />
      {/* {drawerOpen && !matchDownMD && <NavCard />} */}
    </SimpleBar>
  );
};

export default DrawerContent;
